import _ from 'lodash';

export default function (instance) {
  let taskChanges = [];

  const calculateOffset = function (task, oldDate, newDate) {
    let offset;

    if (oldDate.valueOf() < newDate.valueOf()) {
      offset = instance.calculateDuration({
        start_date: oldDate,
        end_date: newDate,
        task: task,
      });
    } else {
      offset = -instance.calculateDuration({
        start_date: newDate,
        end_date: oldDate,
        task: task,
      });
    }

    return offset;
  };

  instance._moveChildren = function (parentId, offset) {
    const children = instance.getChildren(parentId);

    if (instance.hasChild(parentId)) {
      instance.batchUpdate(() => {
        for (let i = 0; i < children.length; i++) {
          instance._moveTasksDates(children[i], offset);
        }
      });
    }
  };

  instance._moveTasksDates = function (taskId, offset) {
    const shouldUpdate = !!offset;

    if (taskId != instance.config.root_id) {
      const task = instance.getTask(taskId);

      if (task.type !== instance.config.types.button) {
        task.start_date = instance.calculateEndDate({
          start_date: task.start_date,
          duration: offset,
          unit: instance.config.duration_unit,
          task: task,
        });
        task.start_date = instance.getClosestWorkTime({ date: task.start_date, dir: 'future', task: task });

        // Reset constraint type for all children
        task.constraint_type = instance.config.constraint_types.ASAP;
        task.constraint_date = null;

        // if (offset < 0 && task.type !== instance.config.types.project) {
        //   offset -= 1;
        // }

        task.end_date = instance.calculateEndDate({
          start_date: task.start_date,
          duration: task.duration,
          unit: instance.config.duration_unit,
          task: task,
        });

        // if (offset < 0 && task.type !== instance.config.types.project) {
        //   task.end_date = instance.calculateEndDate(task.end_date, 1);
        // }

        if (shouldUpdate) {
          taskChanges.push(task);
        }
      }
    }

    instance._moveChildren(taskId, offset);
  };

  instance.moveProject = function (id, newDate, oldDate) {
    instance.callEvent('onBeforeProjectMove', [id]);

    let offset;

    if (id === 1) {
      const children = instance.getChildren(id);
      const projects = _.map(children, id => instance.getTask(id));
      const projectWithMinStartDate = _.minBy(projects, (task) => task.start_date.valueOf());

      offset = calculateOffset(projectWithMinStartDate, projectWithMinStartDate.start_date, newDate);
    } else {
      const task = instance.getTask(id);

      offset = calculateOffset(task, oldDate, newDate);
    }

    taskChanges = [];

    instance._moveChildren(id, offset);
    instance.batchUpdate(() => {
      taskChanges.forEach(task => instance.updateTask(task.id));
    });

    instance.callEvent('onAfterProjectMove', [id]);
  };
}
